// @flow
import React from 'react';
import './ParticipantCard.scss';
import personIcon from '../../assets/head-icon-border_1px.svg';
import { Tooltip } from 'antd';
import type { Participant } from '../../slices/participantSlice';
import ParticipantCardAction from '../participant-card-action/ParticipantCardAction';
import FileTextOutlined from '@ant-design/icons/lib/icons/FileTextOutlined';
import CheckCircleOutlined from '@ant-design/icons/lib/icons/CheckCircleOutlined';
import { useSelector } from 'react-redux';
import type { State } from '../../general/types';
import { formatAddress } from '../../utilities/formatAddress';

export default function ParticipantCard({
  participantId,
}: {
  participantId: number,
}) {
  const participant: Participant = useSelector((state: State) => {
    return state.participants.byId[participantId];
  });

  if (!participant) {
    return <div></div>;
  }

  function presentAddress() {
    const address = participant.effectiveAddress;
    if (address && address.address) {
      const url = address.googleMapUrl;
      const label = address.label ? ` (${address.label})` : '';
      return (
        <a href={`${url}`} target="_blank" rel="noopener noreferrer">
          {formatAddress(address)}
          {label}
        </a>
      );
    }

    return 'No Address Provided';
  }

  return (
    <div className="coach-dashboard participant-card">
      <div className="left-container">
        {<img src={personIcon} alt="head" width="100" height="100"></img>}{' '}
        <div className="name">
          {participant.firstName} {participant.lastName}
          <div className="name-header">Location</div>
          <div className="header-detail">{presentAddress()}</div>
          {participant.skill ? (
            <>
              <div className="name-header">Skill</div>
              <div className="header-detail">{participant.skill.name}</div>
            </>
          ) : (
            ''
          )}
        </div>
        <div className="icons">
          <div>
            {participant.note && (
              <Tooltip title={participant.note}>
                <span>
                  <FileTextOutlined />
                </span>
              </Tooltip>
            )}
          </div>
          <div className="check-mark">
            {participant.requiresMoDropOff && <CheckCircleOutlined />}
          </div>
        </div>
      </div>
      <ParticipantCardAction participant={participant} />
    </div>
  );
}
